import React, { useState } from 'react';
import { AppBar, Toolbar, Typography, Box, Stack, Avatar, Menu, MenuItem, Tooltip, IconButton, Badge } from '@mui/material';
import StarIcon from '@mui/icons-material/Star';
import StarOutlineIcon from '@mui/icons-material/StarOutline';
import ChatBubbleOutlineIcon from '@mui/icons-material/ChatBubbleOutline';
import { useTranslation } from 'react-i18next';
import { useKindeAuth } from "@kinde-oss/kinde-auth-react";
import {  useNavigate, useLocation } from 'react-router-dom';
//import { getProfilePictureURL } from '../api/api';
import {getInitials } from '../utils'
import Logout from '@mui/icons-material/Logout';
import ListItemIcon from '@mui/material/ListItemIcon';
import Divider from '@mui/material/Divider';
import PersonIcon from '@mui/icons-material/Person';
import { useUnreadMessages } from '../contexts/UnreadMessagesContext';

const Header = ({profile, city}) => {
  const { logout, user } = useKindeAuth();
  const isPremium = profile?.premiumExp != null && new Date(profile?.premiumExp) > new Date() 
  const navigate = useNavigate();
  const location = useLocation();
  const [anchorEl, setAnchorEl] = useState(null);
  const [languageAnchorEl, setLanguageAnchorEl] = useState(null);
  const [languageAnchor1El, setLanguageAnchor1El] = useState(null);
  const { t, i18n } = useTranslation();
  const { count: unreadCount } = useUnreadMessages();

  const handleMenuOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const handleLanguageMenu1Open = (event) => {
    setLanguageAnchor1El(event.currentTarget);
  };

  const handleLanguageMenu1Close = () => {
    setLanguageAnchor1El(null);
  };



  const handleLanguageMenuOpen = (event) => {
    setLanguageAnchorEl(event.currentTarget);
  };

  const handleLanguageMenuClose = () => {
    setLanguageAnchorEl(null);
  };

  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng);
    handleLanguageMenuClose();
  };

  const handleProfileClick = () => {
    handleMenuClose();
    navigate('/profile');
  };

  const handleSignOut = () => {
    handleMenuClose();
    logout();
    // The Kinde library will handle the redirection after logout
  };



  const avatarContent = 
      (profile && location.pathname === '/') ?
        (profile.hasPicture ? (
          <Avatar src={profile.profilePictureUrl} alt={user.given_name} />
        ) : (
        <Avatar>{getInitials(`${profile?.firstName || ''} ${profile?.lastName || ''}`.trim())}</Avatar>))
      : null;
  
  return (
    <AppBar position="static" elevation={0} sx={{ backgroundColor: 'background.paper' }}>
      <Toolbar disableGutters sx={{ width: '100%', padding: 0 }}>
      
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '100%' }}>
          <Stack 
            direction="row" 
            spacing={1} 
            alignItems="center" 
            sx={{ 
              marginLeft: 2,
              cursor: 'pointer',
              '&:hover': {
                opacity: 0.8
              }
            }}
            onClick={() => {
              if (location.pathname === '/') {
                window.location.href =  window.SINGLE_DOMAIN ? `https://${window.SINGLE_DOMAIN}.${window.BASE_DOMAIN}/` : `https://app.${window.BASE_DOMAIN}/?map`;
              } else {
                navigate('/');
              }
            }}
          >
            <Box 
              component="img"
              src="/logo256.png"
              alt="Crewbank Logo"
              sx={{ 
                height: 32,
                width: 'auto'
              }}
            />
            
            <Box>
              <Typography variant="h6" component="div" sx={{ color: 'darkblue', fontWeight: 'bold', fontFamily: 'sans-serif', lineHeight: 1.2,    marginTop: '2px', fontSize: '1.2rem'}}>
                Crew Bank
              </Typography>
              {city && (
                <Typography 
                  variant="caption" 
                  component="div" 
                  sx={{ 
                    color: 'text.secondary',
                    //fontStyle: 'italic',
                    fontSize: '0.8rem',
                    marginTop: '-2px'
                  }}
                >
                  {city}
                </Typography>
              )}
            </Box>
          </Stack>
          <Stack direction="row" alignItems="center" spacing={2} sx={{ marginRight: 2 }}>

          {profile && (
            <Tooltip title={t('messages.title')} placement="bottom">
              <IconButton onClick={() => navigate('/messages')} size="medium">
                <Badge color="error" badgeContent={unreadCount}>
                  <ChatBubbleOutlineIcon sx={{ color: 'text.primary' }} />
                </Badge>
              </IconButton>
            </Tooltip>
          )}

          {(!profile || location.pathname !== '/') && (
            <>
            <Box 
              onClick={handleLanguageMenu1Open}
              sx={{ 
                cursor: 'pointer',
                padding: '4px 8px',
                borderRadius: '4px',
                backgroundColor: 'rgba(0,0,0,0.05)',
                transition: 'transform 0.2s, background-color 0.2s',
                '&:hover': {
                  transform: 'scale(1.1)',
                  backgroundColor: 'rgba(0,0,0,0.1)'
                }
              }}
            >
              <Typography variant="body2" sx={{ 
                fontWeight: 'bold', 
                color: 'text.primary',
                fontSize: '0.875rem'
              }}>
                {i18n.language.substring(0, 2).toUpperCase()}
              </Typography>
            </Box>
          
           <Menu
              anchorEl={languageAnchor1El}
              open={Boolean(languageAnchor1El)}
              onClose={handleLanguageMenu1Close}
            >
              <MenuItem onClick={() => changeLanguage('en')} sx={{ gap: 1 }}>
                <Typography variant="body2" sx={{ fontWeight: 'bold', minWidth: 24 }}>
                  EN
                </Typography>
                {t('header.english')}
              </MenuItem>
              <MenuItem onClick={() => changeLanguage('fr')} sx={{ gap: 1 }}>
                <Typography variant="body2" sx={{ fontWeight: 'bold', minWidth: 24 }}>
                  FR
                </Typography>
                {t('header.french')}
              </MenuItem>
            </Menu>
            </>)}
            {profile && location.pathname === '/' && (
              <>
                <Stack spacing={0} onClick={handleMenuOpen} sx={{ cursor: 'pointer', minWidth: 0, maxWidth: { xs: 100, sm: 140 } }}>
                  <Typography
                    variant="body1"
                    noWrap
                    sx={{ color: 'text.primary', lineHeight: 1.2 }}
                  >
                    {profile?.firstName || ''}
                  </Typography>
                  <Typography
                    variant="body1"
                    noWrap
                    sx={{ color: 'text.primary', lineHeight: 1.2 }}
                  >
                    {profile?.lastName || ''}
                  </Typography>
                </Stack>
                <Box sx={{ display: 'flex', alignItems: 'center', position: 'relative' }}>
                  <Box onClick={handleMenuOpen} style={{ cursor: 'pointer' }}>
                    {avatarContent}
                  </Box>
                  {isPremium && (
                    <Tooltip title="Thanks for being Premium" placement="top">
                      <StarIcon 
                        sx={{ 
                          color: '#FFD700',
                          position: 'absolute',
                          right: -10,
                          bottom: -5,
                          fontSize: '1.7rem',
                          filter: 'drop-shadow(1px 1px 1px rgb(78, 47, 9))'
                        }} 
                      />
                         <StarOutlineIcon 
                        sx={{ 
                          color: 'rgb(252, 195, 50)',
                          position: 'absolute',
                          right: -10,
                          bottom: -5,
                          fontSize: '1.7rem',
                        
                        }} 
                      />
                    </Tooltip>
                  )}
                </Box>
              </>
            )}
            <Menu
              anchorEl={anchorEl}
              open={Boolean(anchorEl)}
              onClose={handleMenuClose}
            >
              <MenuItem onClick={handleProfileClick}>
                <ListItemIcon>
                  <PersonIcon fontSize="small" />
                </ListItemIcon>
                {t('header.editProfile')}
              </MenuItem>
              <MenuItem onClick={handleLanguageMenuOpen}>
                <ListItemIcon>
                  <Typography variant="body2" sx={{ fontWeight: 'bold' }}>
                    {i18n.language.substring(0, 2).toUpperCase()}
                  </Typography>
                </ListItemIcon>
                {t('header.language')}
              </MenuItem>
              <Divider />
              <MenuItem onClick={handleSignOut}>              
                <ListItemIcon>
                  <Logout fontSize="small" />
                </ListItemIcon>
                {t('header.logout')}
              </MenuItem>
            </Menu>
            <Menu
              anchorEl={languageAnchorEl}
              open={Boolean(languageAnchorEl)}
              onClose={handleLanguageMenuClose}
              anchorOrigin={{
                vertical: 'top',
                horizontal: 'right',
              }}
              transformOrigin={{
                vertical: 'top',
                horizontal: 'left',
              }}
            >
              <MenuItem onClick={() => changeLanguage('en')} sx={{ gap: 1 }}>
                <Typography variant="body2" sx={{ fontWeight: 'bold', minWidth: 24 }}>
                  EN
                </Typography>
                {t('header.english')}
              </MenuItem>
              <MenuItem onClick={() => changeLanguage('fr')} sx={{ gap: 1 }}>
                <Typography variant="body2" sx={{ fontWeight: 'bold', minWidth: 24 }}>
                  FR
                </Typography>
                {t('header.french')}
              </MenuItem>
            </Menu>
          </Stack>
        </Box>
      </Toolbar>
    </AppBar>
  );
};

export default Header;
